document.addEventListener('DOMContentLoaded', () => {
  const breadcrumbElement = document.getElementById('breadcrumb')
  if (breadcrumbElement) {
    const olElement = breadcrumbElement.querySelector('ol')

    if (olElement) {
      const lastLiElement = olElement.childNodes[3]
      if (lastLiElement) {
        const postType = lastLiElement.childNodes[1].textContent

        if (postType.includes('actualités')) {
          const ulElement = document.querySelector('ul.posts')

          if (ulElement) {
            ulElement.classList.add('formations-block')
          }
        }
      }
    }
  }
})
